import type { WidgetConfig } from 'components/farm-dashboard/types'
import { DOCK_CATEGORIES_TYPES } from '../../../types/dockTypes'
import { CATTLES_WIDGETS } from '../components/cattles-container/cattlesWidgets'
import { FEED_TABLE_WIDGETS } from '../components/food-table-container/feedTableWidgets'
import { HEALTH_TABLE_WIDGETS } from '../components/health-container/healthTableWidgets'
import { MILKING_ROUTINE_TABLE_WIDGETS } from '../components/milking-routine-container/milkingRoutineTableWidgets'
import { MILK_YIELD_TABLE_WIDGETS } from '../components/milk-yield-container/milkYieldTableWidgets'

export type DockCategoryKey = Exclude<
	DOCK_CATEGORIES_TYPES,
	DOCK_CATEGORIES_TYPES.ALL
>

export const WIDGETS_BY_CATEGORY: Record<DockCategoryKey, WidgetConfig[]> = {
	[DOCK_CATEGORIES_TYPES.CATTLES]: CATTLES_WIDGETS,
	[DOCK_CATEGORIES_TYPES.FOOD_TABLE]: FEED_TABLE_WIDGETS,
	[DOCK_CATEGORIES_TYPES.HEALTH]: HEALTH_TABLE_WIDGETS,
	[DOCK_CATEGORIES_TYPES.MILKING_PROCESS]: MILKING_ROUTINE_TABLE_WIDGETS,
	[DOCK_CATEGORIES_TYPES.MILK_YIELD]: MILK_YIELD_TABLE_WIDGETS,
}

export const SECTION_TITLES: Record<DockCategoryKey, string> = {
	[DOCK_CATEGORIES_TYPES.CATTLES]: 'Поголовье',
	[DOCK_CATEGORIES_TYPES.FOOD_TABLE]: 'Кормовой стол',
	[DOCK_CATEGORIES_TYPES.HEALTH]: 'Здоровье',
	[DOCK_CATEGORIES_TYPES.MILKING_PROCESS]: 'Рутина доения',
	[DOCK_CATEGORIES_TYPES.MILK_YIELD]: 'Надои',
}

export const DOCK_SECTIONS: { key: DockCategoryKey; title: string }[] = (
	Object.keys(WIDGETS_BY_CATEGORY) as DockCategoryKey[]
).map(key => ({ key, title: SECTION_TITLES[key] }))
